export default "__VITE_ASSET__D5jbFNG8__"